export default import.meta.ROLLDOWN_FILE_URL_ShLFqVI8xue0ZXbFLAmM8g